import {AfterViewInit, Directive, ElementRef, Input, OnDestroy, Renderer2} from '@angular/core';
import ResizeObserver from 'resize-observer-polyfill';

@Directive({
  selector: '[smartTableSticky]'
})
export class SmartTableStickyDirective implements AfterViewInit, OnDestroy {

  @Input('smartTableSticky') content: Element;

  cloneThead: Element;
  subscriptions: {
    listen: any,
    element: Element
  }[] = [];

  constructor(private elementRef: ElementRef,
              private renderer: Renderer2) { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    const thead = this.elementRef.nativeElement.querySelector('thead');
    const table = this.content.querySelector('table');
    this.cloneThead = thead.cloneNode(true);
    this.renderer.addClass(this.cloneThead, 'smart-table__hidden-header');
    this.renderer.insertBefore(table, this.cloneThead, table.firstChild);

    this.subscriptions = [];
    this.updateTable();
    this.updateCell();
  }

  updateTable() {
    const table = this.content.querySelector('table');

    const resize = new ResizeObserver((entries) => {
      const header = this.elementRef.nativeElement;
      const height = (entries[0].target as any).offsetHeight;
      this.renderer.setStyle(header, 'height', `${height}px`);
      this.renderer.setStyle(table, 'margin-top', `${-height}px`);
    });

    resize.observe(this.cloneThead);

    this.subscriptions.push({
      listen: resize,
      element: this.cloneThead
    });
  }

  updateCell() {
    const thClone = this.cloneThead.querySelectorAll('tr:first-child th');
    const thOrigin = this.elementRef.nativeElement.querySelectorAll('tr:first-child th');

    for (let i = 0; i < thClone.length; i++) {
      const resize = new ResizeObserver((entries, observer) => {
        this.renderer.setStyle(thOrigin[i], 'min-width', `${(entries[0].target as any).offsetWidth}px`);
      });

      resize.observe(thClone[i]);

      this.subscriptions.push({
        listen: resize,
        element: thClone[i]
      });
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(item => {
      item.listen.unobserve(item.element);
      item.listen.disconnect();
    });

    this.subscriptions = [];
  }


}
